import React, { Component } from "react";

import Header from "@components/Header";

class Visuals extends Component {
    render() {
        return (
            <div id="main">
                <Header />
                <section>
                    <header className="content">
                        <h1>Visuals</h1>
                    </header>
                </section>
            </div>
        );
    }
}

export default Visuals;
